import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumbs, Tabs, H1, Loader } from '@itds/elements/index.js';

import Permissions from './Permissions';
import General from './General';
import EmbeddableEtickets from './EmbeddableEtickets';
import Contacts from './Contacts';

import { CarrierContext } from '@carrier/contexts/CarrierContext';
import Api from '@carrier/utils/Api';
import Preview from './etickets/Preview';

const Show = ({ carrier, lifeDxProfile }) => {
  const hash = window.location.hash;
  const navigate = useNavigate();
  const params = useParams();
  const [relationship, setRelationship] = useState({});
  const [loading, setLoading] = useState(true);
  const { setNotification } = useContext(CarrierContext);

  const tabs = [
    {
      label: 'General',
      to: ' ',
      isActive:
        window.location.hash === `#/carriers/${carrier.id}/vendors/${params.vendor_id}` ||
        hash.slice(-1) === '/'.slice(-1)
    }
  ];

  if (lifeDxProfile) {
    if (
      lifeDxProfile.product_permissions.includes('life_quotes_api') ||
      lifeDxProfile.product_permissions.includes('ltc_quotes_api') ||
      lifeDxProfile.product_permissions.includes('forms_api')
    ) {
      tabs.push({
        label: 'Permissions',
        to: 'permissions',
        isActive: window.location.hash.includes('permissions')
      });
    }

    if (lifeDxProfile.product_permissions.includes('embeddable_etickets')) {
      tabs.push({
        label: 'Embeddable E-Tickets',
        to: 'etickets',
        isActive: window.location.hash.includes('etickets')
      });
    }
  }

  tabs.push({
    label: 'Contacts',
    to: 'contacts',
    isActive: window.location.hash.includes('contacts')
  });

  useEffect(() => {
    Api.loadVendorCarrierRelationship(params.vendor_id).then(({ data }) => {
      setRelationship(data);
      setLoading(false);
    });
  }, []);

  const saveRelationship = payload => {
    setLoading(true);

    Api.updateVendorCarrierRelationship(relationship.id, payload)
      .then(({ data }) => {
        setRelationship(data);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        setNotification({
          message: 'Successfully Saved',
          type: 'success'
        });
      })
      .catch(() => {
        setTimeout(() => {
          setNotification({
            message: 'Unable to save at this time',
            type: 'error'
          });
        }, 2000);
      });
  };

  const props = {
    carrier,
    lifeDxProfile,
    relationship,
    saveRelationship,
    setNotification
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <H1>{relationship.name}</H1>
      <Breadcrumbs
        crumbs={[
          { label: 'Vendors', onClick: navigate.bind(null, `/carriers/${carrier.id}/vendors`) }
        ]}
        current={relationship.name}
      />

      <div style={{ display: 'flex', margin: '0 -20px' }}>
        <Tabs tabs={tabs} vertical={true} />

        <div style={{ flex: 1, marginLeft: 40 }}>
          <Routes>
            <Route element={<General {...props} />} index={true} />
            <Route element={<Permissions {...props} />} path='permissions' />
            <Route element={<EmbeddableEtickets {...props} />} path='etickets' />
            <Route element={<Preview {...props} />} path='etickets/:id/preview' />
            <Route element={<Contacts {...props} />} path='contacts' />
          </Routes>
        </div>
      </div>
    </>
  );
};

Show.propTypes = {
  carrier: PropTypes.object,
  lifeDxProfile: PropTypes.object
};

export default Show;
